import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  contentContainer: {
    flexGrow: 1,
    width: "100%",
    overflow: "auto",
    scrollbarGutter: "stable",
  },
  center: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },
  content: {
    marginTop: "auto",
    marginBottom: "auto",
    paddingTop: "32px",
    paddingBottom: "32px",
    display: "flex",
    justifyContent: "center",
  },
  buttons: {
    width: "100%",
    paddingLeft: 32,
    paddingRight: 32,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 86,
      paddingRight: 86,
    },
    overflow: "hidden",
    transition: "height 0.2s ease-in-out",
    flexShrink: 0,
    height: "77px",
    backgroundColor: "#FFFFFF",
    borderTop: `2px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
}));

interface WrapperCenterMessageProps {
  children?: any;
  buttons?: any;
}

export const WrapperCenterMessage = (props: WrapperCenterMessageProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.contentContainer}>
        <Box className={classes.center}>
          <Box className={classes.content}>{props.children}</Box>
        </Box>
      </Box>
      {props.buttons && <Box className={classes.buttons}>{props.buttons}</Box>}
    </Box>
  );
};
